import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-row',
  templateUrl: './user-row.component.html',
  styleUrls: ['./user-row.component.css']
})
export class UserRowComponent {
  @Input() name: string = '';
  @Input() type: string = '';
  @Output() editUser = new EventEmitter<{type: string, name: string}>();
  @Output() setDeleteModalOpened = new EventEmitter<boolean>();

  onEdit(): void {
    this.editUser.emit({type: this.type, name: this.name});
  }
} 